import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { DateFilterItems, InitialFilterDTO } from './filter.constants';
import { Filter } from './filter.interface';
import { DateFilterItemsEnum } from './filter.enum';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent {
  @ViewChild('typeSelect') typeSelect!: MatSelect;

  filter: Filter = {
    ...InitialFilterDTO,
  };
  hasValues: boolean = false;
  dateFilterItemsEnum: DateFilterItemsEnum;
  dateFilterItems = DateFilterItems;

  @Input() showType: boolean = true;
  @Input() showUsers: boolean = true;
  @Input() showCreated: boolean = true;
  @Input() showModified: boolean = true;
  @Input() showSort: boolean = true;

  @Output() filterEvent: EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor() {}

  setFilterValue(event: Filter) {
    this.filter = event;
    this.filterEvent.emit(this.filter);
  }

  openSelect(): void {
    this.typeSelect.open();
  }

  filterIsDirty(): boolean {
    const obj = this.filter;
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (
          obj[key as keyof Filter].value !== null &&
          obj[key as keyof Filter].value !== ''
        ) {
          return true; // If any value property has a value, return true
        }
      }
    }
    return false; // If no value property has a value, return false
  }

  resetFilter() {
    this.filter = InitialFilterDTO;
  }
}
